var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-h-space-between gap-4 mar-bot-l1"},[_c('ui-button',{staticClass:"w-100 btn-action",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('clear')}}},[_c('div',{staticClass:"icon mar-right-2"},[_c('i',{staticClass:"mdi mdi-18px mdi-delete-outline"})]),_vm._v(" Очистить все ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }